/* eslint-disable react/no-array-index-key */
import { useTranslation } from 'react-i18next';
import editableTemplateStyles from '@modules/proposals/presentation/v2/pages/ProposalCreation/es/views/EditableTemplate/styles';
import { Flex, Text } from '@huspy/briks-web';

type OfferDetailsProps = {
  numberOfOffers: number;
};

const BANK_OFFERS_ROW_COLORS = [
  '#FCFAF6',
  '#F7F2E9',
  '#F6EFE4',
  '#F1E6D5',
  '#f2e2c7'
];

export const OfferDetails = ({ numberOfOffers }: OfferDetailsProps) => {
  const { t } = useTranslation();
  const rows = [
    t('common.forms.propertyValue.label'),
    t('common.forms.outstandingLoanAmount.label'),
    t('proposals.template.financial_details.sections.ltv'),
    t('proposals.template.financial_details.sections.interest_type_with_bonus'),
    t(
      'proposals.template.financial_details.sections.interest_type_without_bonus'
    ),
    t('proposals.template.financial_details.sections.hired_products'),
    t('proposals.template.financial_details.sections.differential'),
    t('proposals.template.financial_details.sections.amortization_commission')
  ];
  return (
    <>
      <Flex align='end' gap='2' borderBottom='1px solid black' my='12'>
        <Flex w='200px' bg='black' p='2' justify='center'>
          <Text color='white' size='md'>
            {t('proposals.template.offer_details.title')}
          </Text>
        </Flex>
        <Text size='sm' mb='1'>
          {t('proposals.template.offer_details.disclaimer')}
        </Text>
      </Flex>
      <table>
        <tbody>
          <tr
            style={ {
              pageBreakInside: 'avoid',
              pageBreakAfter: 'auto',
            } }
          >
            <th aria-label='header' />
            {Array.from({ length: numberOfOffers }, (_, index) => (
              <th
                key={ `bank${index}` }
                className={ editableTemplateStyles.offersTableCellHead }
                style={ { background: BANK_OFFERS_ROW_COLORS[index] } }
                contentEditable
                suppressContentEditableWarning
              >
                {t('proposals.template.financial_details.bank', { bankName: index + 1 })}
              </th>
            ))}
          </tr>
          {rows.map((row, index) => (
            <tr key={ `row${index}` } className={ editableTemplateStyles.tableRow }>
              <td className={ editableTemplateStyles.offersTableCellData }>{row}</td>
              {Array.from({ length: numberOfOffers }, (_, cellIndex) => (
                <td
                  key={ `offerField${cellIndex}` }
                  className={ editableTemplateStyles.offersTableCellData }
                  style={ { background: BANK_OFFERS_ROW_COLORS[cellIndex] } }
                  contentEditable
                  suppressContentEditableWarning
                  aria-label='field'
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};
